<template>
  <div id="app">
    <compotent :is="layout" v-if="$route.name" />
  </div>
</template>

<script>
import Vue from 'vue'
import store from './store'

export default {
  name: 'App',
  computed: {
    layout() {
      return (this.$route.meta.layout || 'default') + '-layout';
    }
  },
  created: async() => {
    const params = { web_page_code:  process.env.VUE_APP_WEB_PAGE_CODE }
    const curVersion = await store.dispatch('api/getKuraemonCloudWebPageVersion', params)

    if (store.getters['api/apiError']) {
      console.log('apiError')
      return;
    }
    const VERSION_KEY = "KURAEMON_CLOUD_WEB_VERSION"
    const storedVersion = Vue.$cookies.get(VERSION_KEY);
    Vue.$cookies.set(VERSION_KEY, curVersion, "10d")

    if (String(storedVersion) !== String(curVersion)) {
      // バージョンが更新されている場合はページをリロードする
      window.location.reload(true);
      console.log('curVersion', curVersion)
      console.log('storedVersion', storedVersion)
      console.log('window.location.reload')
    }
  }
}
</script>

<style>
html {
  box-sizing: border-box;
  font-size: 14px;
  font-family: "Helvetica Neue", Arial, "Hiragino kaku Gothic ProN", "Hiragino Sans", Meiryo, sans-serif;
  height: 100%;
}
body {
  margin: 0;
  font-size: 1rem;
  height: 100%;
}
#app {
  height: 100%;
}
*,
*::before,
*::after {
  box-sizing: inherit;
}
</style>